import { State } from '@meraki-internal/state';
import { UserOnboardingState } from '../onboarding/UserOnboardingState';
import { HistoryViewModel } from '../support/HistoryViewModel';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { AsyncStorageProvider } from '../support/AsyncStorageProvider';

const SEARCH_PARAM_KEY = 'openChat';
export const HELPER_BEE_OPENED_STORAGE_KEY = 'helper-bee-opened';

export type IHelperBeeTrackingFrom = 'Welcome' | 'Caregiver Tools' | 'Onboarding To Do' | 'Onboarding Revisited' | 'Deep Link' | 'Care Recipient Added';

export class HelperBeeViewModel extends State<Record<string, never>> {
    private _isOpen = false;

    static inject = () => [
        UserOnboardingState,
        HistoryViewModel,
        MixPanelEventEmitter,
        AsyncStorageProvider
    ];
    constructor(
        private userOnboardingState: UserOnboardingState,
        private history: HistoryViewModel,
        private mixpanel: MixPanelEventEmitter,
        private storageProvider: AsyncStorageProvider
    ) {
        super({ });

        this.history.listen(this.openIfSearchParam);
        this.openIfSearchParam();
    };

    private openIfSearchParam = () => {
        const params = this.history.getCurrentSearchParamMap();
        if (params[SEARCH_PARAM_KEY] !== undefined) {
            this.open({ trackingFrom: 'Deep Link' });
        }
    };

    isOpen = () => this._isOpen;

    setStorageOpened = async () => {
        await this.storageProvider.getBooleanProvider(HELPER_BEE_OPENED_STORAGE_KEY).set(true);
    };

    open = ({ trackingFrom, label, ignoreOnboarding }: { trackingFrom: IHelperBeeTrackingFrom; label?: string; ignoreOnboarding?: boolean; }) => {
        if (!ignoreOnboarding) {
            this.setStorageOpened();
            this.userOnboardingState.completeStep('opened-bea');
        }

        this._isOpen = true;
        this.setState({ });

        this.mixpanel.track('AI Chatbot Opened', () => ({ from: trackingFrom, 'Message': label }));
    };

    close = () => {
        this._isOpen = false;
        this.history.removeSearchParam(SEARCH_PARAM_KEY);
        this.setState({ });
    };
};
